import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import {
  approveSinister,
  fetchSinisters,
  revokeSinister,
  sinisterSalesMassive
} from '../../../actions/sinister_actions';
import SinisterList from './SinisterList';

function mapStateToProps(state) {
  const { sinisters, meta } = state.sinister;
  return {
    sinisters,
    meta,
    requestSend: state.requestState.requestSend,
    requestRevokeSinisterSend: state.requestState.requestRevokeSinisterSend,
    requestSinisterSalesMassiveSend:
      state.requestState.requestSinisterSalesMassiveSend,
    requestApproveSinisterSend: state.requestState.requestApproveSinisterSend,
    canApproveSinister: state.authentication.currentUser.canApproveSinister,
    canRevokeSinister: state.authentication.currentUser.canRevokeSinister,
    canCreateRevokeMassiveSinisterSales:
      state.authentication.currentUser.canCreateRevokeMassiveSinisterSales,
    sinisterRegisterCauses: state.globalSetting.orgData.sinister_register_causes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchSinisters: bindActionCreators(fetchSinisters, dispatch),
    approveSinister: bindActionCreators(approveSinister, dispatch),
    revokeSinister: bindActionCreators(revokeSinister, dispatch),
    sinisterSalesMassive: bindActionCreators(sinisterSalesMassive, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(SinisterList);
